import { useEffect } from "react";

const useDirectionChange = (pageProps) => {
  useEffect(() => {
    document.body.dir = pageProps?.app?.direction || "ltr";
  }, [pageProps?.app?.direction]);
};
export default useDirectionChange;